import {
    IconKey,
    IconKeyFilled,
    IconMessage,
    IconMessageFilled,
    IconSquareRoundedPlus,
    IconSquareRoundedPlusFilled,
    IconTag,
    IconTagFilled,
    IconUser,
    IconUserFilled,
} from "@tabler/icons-react";
import {
    ROUTE_ADD_ITEM,
    ROUTE_CHAT,
    ROUTE_LOGIN,
    ROUTE_SETTING,
    ROUTE_SHOP,
} from "../../../const/routes";
import { UserRole } from "../../../types/User.ts";
import ChatUnread from "../../chat/core/ChatUnread.tsx";
import Authorized from "../../core/auth/Authorized";
import CurrentUser from "../../core/auth/CurrentUser.tsx";
import ThemeToggle from "../../core/theme/ThemeToggle.tsx";
import UserTitle from "../../user/core/UserTitle";
import HangerButton from "./HangerButton";
const Hanger = () => {
  return (
    <header className="lg:grid left-0 right-0 fixed hidden top-0 z-10 safe-top">
      <nav className="glass-blurry rounded-field flex transition-all m-2">
        <div className="navbar-start">
          <ul className="menu menu-horizontal gap-2">
            <HangerButton
              icon={<IconTag stroke={2} />}
              iconActive={<IconTagFilled />}
              label={"anzeigen"}
              to={ROUTE_SHOP()}
            />
            <HangerButton
              icon={<IconSquareRoundedPlus stroke={2} />}
              iconActive={<IconSquareRoundedPlusFilled />}
              label="erstellen"
              to={ROUTE_ADD_ITEM()}
            />
            <HangerButton
              icon={<IconMessage stroke={2} />}
              iconActive={<IconMessageFilled />}
              label="schreiben"
              to={ROUTE_CHAT()}
            >
              <Authorized>
                <ChatUnread />
              </Authorized>
            </HangerButton>

            <Authorized
              role={UserRole.Unverified}
              ifUnauthorized={
                <HangerButton
                  icon={<IconKey stroke={2} />}
                  iconActive={<IconKeyFilled />}
                  label={"anmelden"}
                  to={ROUTE_LOGIN}
                />
              }
            >
              <CurrentUser>
                {(userId) => (
                  <HangerButton
                    icon={<IconUser stroke={2} />}
                    iconActive={<IconUserFilled />}
                    label={<UserTitle userId={userId} />}
                    to={ROUTE_SETTING}
                  />
                )}
              </CurrentUser>
            </Authorized>
          </ul>
        </div>
        <div className="navbar-center">

        </div>
        {/* Right Section with Theme Switcher and Avatar */}
        <div className="navbar-end">
          <ul className="pr-2">
            <ThemeToggle className="btn btn-ghost btn-circle p-0 flex items-center justify-center" />
          </ul>
        </div>
      </nav>
    </header>
  );
};
export default Hanger;
